import { ApiInstance } from '@src/services/api-instance';
import { ToolsRequestsService } from './requests/api-requests';
import { ToolsTemplatesService } from './templates/api-templates';

export class ToolsScriptsService {
  private readonly client: ApiInstance;
  public requests: ToolsRequestsService;
  public templates: ToolsTemplatesService;

  constructor(client: ApiInstance) {
    this.client = new ApiInstance(`${client.getBaseUrl()}/scripts`, client.getTimeout());
    this.requests = new ToolsRequestsService(this.client);
    this.templates = new ToolsTemplatesService(this.client);
  }
}
